/*
 * File: d:\projects\AutoFiFront\src\Content\ToTopButton\ToTopButton.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday February 22nd 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Wednesday, 13th December 2023 04:13:19
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { useEffect, useState, Fragment } from 'react';
import styles from 'Content/ToTopButton/ToTopButton.module.css';
import ButtonAlt from 'Theme/Component/ButtonAlt';
import { TbArrowBigUp } from "react-icons/tb";

function ToTopButton(props:{themeColor: string}) {
    const [backToTop, setBackToTop] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 300)
                setBackToTop(true);
            else
                setBackToTop(false);
        })
    });

    const scrollUp = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return(
        <Fragment>
                {
                    backToTop ?
                        <div className={`${styles.scrollTop}`}>
                            <ButtonAlt minWidth={"100%"} bgColor={props.themeColor} onClick={scrollUp}><TbArrowBigUp size={"2rem"}/></ButtonAlt>
                        </div>
                        :null
                }
        </Fragment>
    );
};

export default ToTopButton;
